/**
 * ToolsAccordion Component
 * A collapsible container for grouping multiple tool components
 */

import React, { useState, ReactNode } from 'react';
import { ChevronDown, ChevronRight, Wrench } from 'lucide-react';

interface ToolsAccordionProps {
  title: string;
  children: ReactNode;
}

export function ToolsAccordion({ title, children }: ToolsAccordionProps) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className="mt-4 bg-dark-100 rounded-lg border border-gray-700">
      {/* Header - Always Visible */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-dark-200 transition-colors rounded-lg"
      >
        <div className="flex items-center gap-2">
          <Wrench className="w-5 h-5 text-blue-400" />
          <span className="font-semibold text-gray-100">{title}</span>
        </div>
        <div className="flex items-center gap-2">
          {isCollapsed ? (
            <ChevronRight className="w-5 h-5 text-gray-400" />
          ) : (
            <ChevronDown className="w-5 h-5 text-gray-400" />
          )}
        </div>
      </button>

      {/* Collapsible Content */}
      {!isCollapsed && (
        <div className="px-4 pb-4 space-y-4 animate-fade-in">
          {children}
        </div>
      )}
    </div>
  );
}